import { render } from "./ErrorWarningIcon.vue?vue&type=template&id=6e4bacba"
import script from "./ErrorWarningIcon.vue?vue&type=script&lang=js"
export * from "./ErrorWarningIcon.vue?vue&type=script&lang=js"
script.render = render

export default script